import apiSlice from '../api/api.slice';
import { IPostWithUserAndAttachments } from '../post/post';
import { IProjectGroupCardItem } from '../projectGroup/projectGroup.d';
import {
  ICreateBookmarkRequest,
  IDeleteBookmarkRequest,
  ICreateBookmarkResponse,
  IDeleteBookmarkResponse,
  ICreateProjectGroupBookmarkResponse,
  IDeleteProjectGroupBookmarkResponse,
} from './bookmark.d';

const bookmarkApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    createBookmark: builder.mutation<
      ICreateBookmarkResponse,
      ICreateBookmarkRequest
    >({
      query: ({ postId }) => ({
        url: `/api/v1/bookmark/create`,
        method: 'POST',
        body: {
          postId,
        },
      }),
    }),
    deleteBookmark: builder.mutation<
      IDeleteBookmarkResponse,
      IDeleteBookmarkRequest
    >({
      query: ({ postId }) => ({
        url: `/api/v1/bookmark/delete?postId=${postId}`,
        method: 'DELETE',
      }),
    }),
    getBookmarks: builder.query<IPostWithUserAndAttachments[], void>({
      query: () => ({
        url: `/api/v1/bookmark/getBookmarkedPosts`,
        method: 'GET',
      }),
      transformResponse: (response: { posts: IPostWithUserAndAttachments[] }) =>
        response.posts,
    }),
    createProjectGroupBookmark: builder.mutation<
      ICreateProjectGroupBookmarkResponse,
      string
    >({
      query: (projectGroupId) => ({
        url: `/api/v1/bookmark/project-group/create`,
        method: 'POST',
        body: {
          projectGroupId,
        },
      }),
    }),
    deleteProjectGroupBookmark: builder.mutation<
      IDeleteProjectGroupBookmarkResponse,
      string
    >({
      query: (projectGroupId) => ({
        url: `/api/v1/bookmark/project-group/delete?projectGroupId=${projectGroupId}`,
        method: 'DELETE',
      }),
    }),
    getBookmarkedProjectGroups: builder.query<IProjectGroupCardItem[], void>({
      query: () => ({
        url: `/api/v1/bookmark/getBookmarkedProjectGroups`,
        method: 'GET',
      }),
      transformResponse: (response: {
        projectGroups: IProjectGroupCardItem[];
      }) => response.projectGroups,
    }),
  }),
});

apiSlice.enhanceEndpoints({
  addTagTypes: ['Bookmark'],
  endpoints: {
    createBookmark: {
      invalidatesTags: ['Post', 'Bookmark'],
    },
    deleteBookmark: {
      invalidatesTags: ['Post', 'Bookmark'],
    },
    getBookmarks: {
      providesTags: ['Bookmark'],
    },
    createProjectGroupBookmark: {
      invalidatesTags: ['ProjectGroup', 'ProjectGroupList', 'Bookmark'],
    },
    deleteProjectGroupBookmark: {
      invalidatesTags: ['ProjectGroup', 'ProjectGroupList', 'Bookmark'],
    },
    getBookmarkedProjectGroups: {
      providesTags: ['Bookmark'],
    },
  },
});

export const {
  useCreateBookmarkMutation,
  useDeleteBookmarkMutation,
  useGetBookmarksQuery,
  useCreateProjectGroupBookmarkMutation,
  useDeleteProjectGroupBookmarkMutation,
  useGetBookmarkedProjectGroupsQuery,
} = bookmarkApiSlice;
